import React, { useEffect, useState } from "react";

import { instanceToken } from "../../../utils/constant";
import { Link } from "react-router-dom";

import DirectionsIcon from "@mui/icons-material/Directions";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import * as XLSX from "xlsx";
import {
  Breadcrumbs,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  TablePagination,
  InputBase,
} from "@mui/material";

import user3Service from "../../../services/user3Service";

export default function User3s() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [users, setUsers] = useState(null);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const fetchAllData = async (search) => {
    try {
      const res = await user3Service.getAllUsersData(
        instanceToken.token,
        search
      );
      setData(res.data.cust_user);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  useEffect(() => {
    fetchUsers(rowsPerPage, offset);
    fetchAllData();
  }, [offset, rowsPerPage]);
  console.log(data);
  useEffect(() => {
    fetchSearchByName(search);
  }, [search]);

  const fetchSearchByName = async (search) => {
    try {
      const res = await user3Service.searchUser(instanceToken.token, search);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(document.getElementById("search-by-name").value);
  };

  const fetchUsers = async (limit, offset) => {
    try {
      const res = await user3Service.getAllUsers(
        instanceToken.token,
        limit,
        offset
      );

      parse(res.data);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    console.log("data are ", data);
    setUsers(data.cust_user);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    console.log("taget value", event.target.value);
    setPage(0);
  };

  const exportAllData = () => {
    const dataToExport = data.map((u) => ({
      SystemID: u.customer_id,
      CustomerID: u.code,
      User_Name: u.name,
      Phone: u.phone_number,
      Email: u.email,
      Address: u.address,
      Role: u.role,
      Otp_Exp_Time: u.otp_exp_time,
      One_Time_Password: u.one_time_password,
    }));

    const date = new Date();
    const boldCellStyle = { font: { bold: true } };
    const xls = XLSX.utils.json_to_sheet(dataToExport);
    xls["!cols"] = [{ wch: 20 }, { wch: 15 }, { wch: 20 }];
    xls["A1"].s = boldCellStyle;
    xls["B1"].s = boldCellStyle;
    xls["C1"].s = boldCellStyle;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, xls, "Receipt Data");
    const fileName = date.toISOString();
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const exportPaginateData = () => {
    const dataToExport = users.map((u) => ({
      SystemID: u.customer_id,
      CustomerID: u.code,
      User_Name: u.name,
      Phone: u.phone_number,
      Email: u.email,
      Address: u.address,
      Role: u.role,
      Otp_Exp_Time: u.otp_exp_time,
      One_Time_Password: u.one_time_password,
    }));

    const date = new Date();
    const boldCellStyle = { font: { bold: true } };
    const xls = XLSX.utils.json_to_sheet(dataToExport);
    xls["!cols"] = [{ wch: 20 }, { wch: 15 }, { wch: 20 }];
    xls["A1"].s = boldCellStyle;
    xls["B1"].s = boldCellStyle;
    xls["C1"].s = boldCellStyle;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, xls, "Receipt Data");
    const fileName = date.toISOString();
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  if (!users) {
    return <em>Loading</em>;
  }

  //Change data from String to object with JSON
  // if (typeof res.data.address !== "object") {
  //   try {
  //     let address = JSON.parse(res.data.address);
  //     user = { ...result.data.users_by_pk, address };
  //   } catch (e) {
  //     user = { ...result.data.users_by_pk };
  //   }
  // } else user = { ...result.data.users_by_pk, address: "-" };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 35,
        }}
      >
        <div>
          <div role="presentation" style={{ marginBlockEnd: "10px" }}>
            <Breadcrumbs aria-label="breadcrumb">
              <span>User Level 3 </span>
            </Breadcrumbs>
          </div>
          <div>
            <Button variant="contained" onClick={exportAllData}>
              Export All Excel
            </Button>
            <Button
              style={{ marginLeft: "30px" }}
              variant="contained"
              onClick={exportPaginateData}
            >
              Export to Excel
            </Button>
          </div>
        </div>
        {/* search */}
        <div>
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 350,
            }}
          >
            {/* Search Box */}

            <InputBase
              id="search-by-name"
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search By Customer ID"
              type="search"
            />

            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton
              color="primary"
              id="search-by-id"
              sx={{ p: "10px" }}
              aria-label="directions"
              value={search}
              onClick={handleSearch}
            >
              <DirectionsIcon />
            </IconButton>
          </Paper>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "end" }}>
        {/* <Button
          variant="contained"
          sx={{ my: 3 }}
          onClick={() => navigate("/createBanner")}
        >
          Create
        </Button> */}
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple-table">
          <TableHead>
            <TableRow className="thead">
              <TableCell>ID</TableCell>
              {/* <TableCell>Bank account Number</TableCell>
              <TableCell>Bank Verify Status</TableCell> */}
              <TableCell>Customer ID</TableCell>
              <TableCell>Customer Code</TableCell>
              <TableCell>Email</TableCell>
              {/* <TableCell>Otp_exp_time</TableCell> */}
              <TableCell>Name</TableCell>
              {/* <TableCell>One time password</TableCell>
              <TableCell>Password</TableCell> */}
              <TableCell>Phone Number</TableCell>
              {/* <TableCell>Policy Number</TableCell> */}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users
              .filter((f) => {
                return search === "" ? f : f.customer_id.includes(search);
              })
              .map((row) => (
                <TableRow
                  key={row.userid}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.userid}
                  </TableCell>
                  {/* <TableCell>{row.bank_acct_num}</TableCell>
                <TableCell>{row.bank_verify_status}</TableCell> */}
                  <TableCell>{row.customer_id}</TableCell>
                  <TableCell>{row.code}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  {/* <TableCell>{row.otp_exp_time}</TableCell> */}
                  <TableCell>{row.name}</TableCell>
                  {/* <TableCell>{row.one_time_password}</TableCell>
                <TableCell>{row.password}</TableCell> */}
                  <TableCell>{row.phone_number}</TableCell>
                  {/* <TableCell>{row.policy_num}</TableCell> */}
                  <TableCell>
                    <Button
                      size="small"
                      component={Link}
                      color="secondary"
                      to={`/users3/${row.userid}`}
                    >
                      Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
}
